<template>
  <VView class="panel-login" :header="$t('panelLogin.header')">
    <VForm ref="form"
      :fields="fields"
      @update="onFormUpdate($event)"
    />

    <VBlock max-width="500px">
      <transition name="bounceUp" appear>
        <VButton @click="next()">{{ $t('panelLogin.next') }}</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
import { mapState } from 'vuex';
import { FIELD_TYPE_EMAIL } from '@/components/VForm.vue';
import { SET_LOGIN_FIELD } from '@/store';

export default {
  name: 'PanelLogin',

  computed: {
    ...mapState({
      fields(state) {
        return [
          {
            key: 'email',
            type: FIELD_TYPE_EMAIL,
            isRequired: true,
            label: this.$t('panelLogin.email'),
            value: state.login.email,
            width: 100,
          },
        ];
      },

      payload: state => ({
        email: state.login.email,
      }),
    }),
  },

  data: () => ({
    isSubmitting: false,
  }),

  methods: {
    onFormUpdate({ key, value }) {
      this.$store.commit(SET_LOGIN_FIELD, { key, value });
    },

    async next() {
      const canSubmit = !this.isSubmitting && this.$refs.form.validate();

      if (!canSubmit) { return; }

      this.isSubmitting = true;

      try {
        await this.$bricodes.login(this.payload);
      } catch (error) {
        console.log(error);
      }

      this.isSubmitting = false;

      // this.$router.push('/panel');
    },
  },
};
</script>
